import { css } from 'styled-components';

// Keep menu structure and collapse behavior intact; share the dashboard palette.
export const sidebarStyles = css`
  .ant-layout-sider-light {
    background: #fff;
    box-shadow: 1px 0 0 #edf0f7;
  }
  .ant-layout-sider-light .sidebar-nav-title {
    color: #9299b1;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1.1px;
    margin-bottom: 16px;
  }
  .ant-layout-sider-light .ant-menu {
    font-size: 13px;
    background: transparent;
  }
  .ant-layout-sider-light .ant-menu:not(.ant-menu-inline-collapsed) {
    .ant-menu-item,
    .ant-menu-submenu > .ant-menu-submenu-title {
      height: 42px;
      line-height: 42px;
      margin-top: 3px;
      margin-bottom: 3px;
      border-radius: 8px;
      transition: background-color 160ms ease, color 160ms ease;
    }
    > .ant-menu-item,
    > .ant-menu-submenu > .ant-menu-submenu-title {
      width: calc(100% - 24px);
      margin-inline: 12px;
    }
    .ant-menu-item a, .ant-menu-submenu-title span { font-weight: 400; color: #4b526d; }
    .ant-menu-item svg, .ant-menu-submenu-title svg { color: #9299b1; stroke-width: 1.6px; }
    .ant-menu-item:hover, .ant-menu-submenu-title:hover { background: #f7f7fc; }
    .ant-menu-item:hover a, .ant-menu-submenu-title:hover span { color: #5f63f2; }
    .ant-menu-item-selected {
      background: linear-gradient(100deg, #eeedff, #f6f5ff);
      border-radius: 8px;
    }
    .ant-menu-item-selected a, .ant-menu-item-selected span,
    .ant-menu-item-selected svg { color: #5f63f2; font-weight: 500; }
    .ant-menu-submenu-selected > .ant-menu-submenu-title span,
    .ant-menu-submenu-open > .ant-menu-submenu-title svg { color: #5f63f2; }
    .ant-menu-submenu > .ant-menu-sub {
      background: transparent;
      padding-block: 4px;
    }
    .ant-menu-sub .ant-menu-item {
      width: calc(100% - 28px);
      margin-inline: 14px;
      font-size: 13px;
      height: 38px;
      line-height: 38px;
    }
  }
  .ant-layout-sider-light .ant-menu-inline-collapsed > .ant-menu-item-selected {
    background: #f0eeff;
    border-radius: 8px;
  }
  @media (max-width: 991px) {
    .ant-layout-sider-light { box-shadow: 6px 0 24px rgba(39,43,65,0.08); }
    .ant-layout-sider-light .ant-menu:not(.ant-menu-inline-collapsed) {
      .ant-menu-item, .ant-menu-submenu > .ant-menu-submenu-title {
        height: 44px;
        line-height: 44px;
      }
    }
  }
`;
